import { GRID_STRING_COL_DEF } from "@mui/x-data-grid";
import { Box, Skeleton } from "@mui/material";
import { getLogoUrl } from "../../utilities/consts";
import { LiveIcon } from "../Shared/TableCells/LiveIcon.js";
import { getPlatform } from "../../utilities/orientationAndPlatform.js";
import { useState } from "react";

export function LogoCell(params) {
    const platform = getPlatform();
    const row = params.row;
    const channelID = row.channel_id;
    const { isLive } = params.row;
    const [loading, setLoading] = useState(true);

    const logoHeight = platform === "mobile" ? "1rem" : "2rem";
    const logoWidth = platform === "mobile" ? "2rem" : "4rem";
    const boxHeight = platform === "mobile" ? "3rem" : "4rem";

    function loadStationLogo(e) {
        e.target.onError = null;
        e.target.src = "/logos/sinclair-broadcast-group-white.svg";
    }

     return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                height: "100%",
            }}
        >
            {/* Live Icon on the left */}
            {isLive && (
                <LiveIcon logoHeight = {boxHeight}/>
            )}

            {/* Spacer and centered content */}
            <Box
                sx={{
                    display: "flex",
                    flexGrow: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    backgroundColor: "#007CEB", //#1F3F66
                    height: boxHeight,

                }}
            >
                {loading && (
                    <Skeleton
                        variant="rectangular"
                        width={logoWidth}
                        height={logoHeight}
                        sx={{ position: "absolute" }}
                    />
                )}

                <Box
                    component="img"
                    onLoad={() => setLoading(false)}
                    loading="lazy"
                    src={`${getLogoUrl()}/${channelID}.svg`}
                    alt=""
                    onError={loadStationLogo}
                    sx={{
                        height: logoHeight,
                        Width: logoWidth,
                        objectFit: "contain",
                        flexShrink: 0,
                        opacity: loading ? 0 : 1,
                        transition: "opacity 0.3s ease-in-out",
                    }}
                />
            </Box>
        </Box>
    );
}


export function LogoCellType() {
    return {
        ...GRID_STRING_COL_DEF,
        type: "custom",
        resizable: false,
        filterable: false,
        sortable: false,
        editable: false,
        groupable: false,
        display: "flex",
    };
}
